import React from "react";
import { useElementAttachmentsRetrieval } from "@planzone/view-models";
import { Props } from "./types";
import { AttachmentsIcon } from "./attachmentIcon";
import styles from "./styles.scss";

function AttachmentsCount({ fileNbr }: Props) {
  const count = fileNbr;

  return count === 0 ? (
    <div className={styles.commentsCount}>
      <p className={styles.count} />
      <div className={styles.icon} />
    </div>
  ) : (
    <div className={styles.commentsCount}>
      <p className={styles.count}>{count}</p>
      <AttachmentsIcon className={styles.icon} />
    </div>
  );
}

export { AttachmentsCount };
